import { useMutation } from "@tanstack/react-query";

import { verifyCode } from "~/patients/api/verificationCode";

export const useVerifyCode = () => {
  return useMutation({
    mutationFn: verifyCode,
  });
};
